import { CircularProgress } from "@mui/material";

interface ButtonProps {
  onClick: () => void;
  text: string;
  disabled?: boolean;
  loading?: boolean;
  variant?: 'primary' | 'secondary' | 'outline' | 'ghost';
  className?: string;
}

const Button = ({ onClick, text, disabled = false, loading = false, variant = 'primary', className = '' }: ButtonProps) => {
  const getButtonStyles = () => {
    const baseStyles = 'w-full min-h-[48px] px-8 py-3 rounded-2xl transition-all duration-200 shadow-md hover:shadow-lg disabled:opacity-60 disabled:cursor-not-allowed';
    
    switch (variant) {
      case 'primary':
        return `${baseStyles} bg-[#2E5D7D] text-white hover:opacity-90`;
      case 'secondary':
        return `${baseStyles} bg-white text-black border-2 border-[#999] hover:bg-gray-50`;
      case 'outline':
        return `${baseStyles} bg-transparent text-[#2E5D7D] border-2 border-[#2E5D7D] hover:bg-[#2E5D7D] hover:text-white`;
      case 'ghost':
        return `${baseStyles} bg-transparent text-[#2E5D7D] hover:bg-gray-100`;
      default:
        return `${baseStyles} bg-[#2E5D7D] text-white hover:opacity-90`;
    }
  };

  return (
    <button
      className={`${getButtonStyles()} ${className}`}
      onClick={onClick}
      disabled={disabled || loading}
    >
      {loading ? (
        <div className="flex justify-center items-center">
          <CircularProgress color="inherit" size={20} />
        </div>
      ) : (
        <div className="text-base font-semibold">{text}</div>
      )}
    </button>
  );
};

export default Button;